import PropTypes from "prop-types";
import style from "./styles";
import {
  getDisplayPrice,
  getSelectionMessages,
} from "../../utils/subscriptionMessages";

const getOptionClassName = (isSelected, isOnlyOption) =>
  isSelected && !isOnlyOption
    ? `${style.option} ${style.selected}`
    : style.option;

// TODO(i18n): replace with a localised singular/plural trial-duration key.
const getTrialDurationLabel = (trialOffer) =>
  trialOffer ? `${trialOffer.periodInDays} Days` : undefined;

const PremierSubscriptionOption = ({
  option,
  isPrimary,
  isSelected,
  isDisabled,
  isOnlyOption,
  onSelect,
  currency,
  language,
  freeLabel,
}) => {
  const messages = getSelectionMessages(
    option,
    language,
    currency,
    getTrialDurationLabel(option.trialOffer)
  );
  const { price, standardPrice } = getDisplayPrice(
    option,
    language,
    currency,
    freeLabel
  );

  return (
    <label
      className={getOptionClassName(isSelected, isOnlyOption)}
      data-primary={isPrimary || undefined}
    >
      <input
        className={style.input}
        type="radio"
        name="subscription-plan"
        value={option.id}
        checked={isSelected}
        disabled={isDisabled}
        onChange={() => onSelect(option.id)}
      />
      {messages.badge && !isOnlyOption && (
        <span
          className={
            isSelected ? `${style.badge} ${style.badgeSelected}` : style.badge
          }
        >
          {messages.badge}
        </span>
      )}
      {!isOnlyOption && <span className={style.radio} aria-hidden="true" />}
      <span className={style.details}>
        {messages.duration && (
          <span className={style.planName}>{messages.duration}</span>
        )}
        {messages.callout && (
          <span className={style.callout}>{messages.callout}</span>
        )}
        <span className={style.pricing}>
          <span className={style.priceGroup}>
            <span
              className={
                option.trialOffer
                  ? `${style.price} ${style.priceFree}`
                  : style.price
              }
            >
              {price}
            </span>
            {standardPrice && (
              <span className={style.standardPrice}>{standardPrice}</span>
            )}
            {messages.monthlyPrice && (
              <span className={style.monthlyPrice}>
                {messages.monthlyPrice}
              </span>
            )}
          </span>
        </span>
      </span>
    </label>
  );
};

PremierSubscriptionOption.propTypes = {
  option: PropTypes.shape({
    id: PropTypes.number.isRequired,
    price: PropTypes.object.isRequired,
    period: PropTypes.number.isRequired,
    messages: PropTypes.array.isRequired,
    trialOffer: PropTypes.object,
  }).isRequired,
  isPrimary: PropTypes.bool,
  isSelected: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isOnlyOption: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  currency: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  freeLabel: PropTypes.string.isRequired,
};

export default PremierSubscriptionOption;
